import { ApiError } from './api-error';

/**
 * Check if an error indicates that OAuth reconnection is required
 */
export function requiresOAuthReconnection(error: unknown): boolean {
  if (!error) return false;

  // Check if it's our ApiError with requiresReconnection flag
  if (error instanceof ApiError && error.details?.requiresReconnection === true) {
    return true;
  }

  // Fallback: check error message for reconnection keywords
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    return message.includes('reconnect') || message.includes('re-authorize') || message.includes('reauthorize');
  }

  return false;
}

/**
 * Extract OAuth provider from error details
 */
export function getOAuthProviderFromError(error: unknown): string | undefined {
  if (error instanceof ApiError) {
    return error.details?.provider;
  }
  return undefined;
}
